import { render, staticRenderFns } from "./IconArrowTopRightBottomLeft.vue?vue&type=template&id=bfaf324c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports